import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dependent-fields"
export default class extends Controller {
  static targets = ["field", "multipleFields", "singleFields"];

  radioButtonToggle(event) {
    if (event.target.value === "true") {
      this.fieldTarget.classList.remove("hidden");
    } else {
      this.fieldTarget.classList.add("hidden");
    }
  }

  multipleFieldsToggle(event) {
    if (event.target.value === "true") {
      this.multipleFieldsTarget.classList.remove("hidden");
      this.singleFieldsTarget.classList.add("hidden");
    } else {
      this.multipleFieldsTarget.classList.add("hidden");
      this.singleFieldsTarget.classList.remove("hidden");
    }
  }
}
